// WarningModal.js
import React from 'react'
import Modal from 'components/Modal'
import { showErrorToast } from 'utils/toast'
import { cancelReassessmentRequest } from 'api/siteSpecie'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { FormattedMessage } from 'react-intl'
import WarnFlowRequestModal from 'components/FlowRequestModal/WarnFlow'

const WarningModal = ({ isOpen, setIsOpen, closeEditSpeciesModal, site, item, setSiteProposalFieldValidation }) => {
  const confirmAction = () => {
    cancelReassessmentRequest({ siteId: site.historyId, specieId: item.historyId, isCancelled: true }).then((data) => {
      if (data.error) {
        return showErrorToast(data.error)
      }
      setSiteProposalFieldValidation(defaultSiteProposalValidationResults)
      setIsOpen(false)
      closeEditSpeciesModal()
    })
  }

  return (
    <Modal width='416px' isOpen={isOpen} toggleModal={() => {
      return setIsOpen(!isOpen)
    }} modalTitleId='warningModalHeader'>
      <WarnFlowRequestModal
        cancelHandler={() => {
          return setIsOpen(false)
        }}
        confirmHandler={confirmAction}
        confirmBtnText='yesCancel'
        rejectBtnText='continueEditing'
        text={<FormattedMessage id='warningModalExplanation' />}
        item={item}
        approve={true}
      />
    </Modal>
  )
}

export default WarningModal
